import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Dropdown, UIKits } from "../../../Constants/Constants";
import BasicDropdown from "./BasicDropdown";
import RoundedDropdown from './RoundedDropdown';
import SplitDropdown from './SplitDropdown'
import HeadingDropdown from './HeadingDropdown'
import DropdownWithInput from './DropdownWithInput'
import DarkDropdown from './DarkDropdown'
import UniqueDropdown from './UniqueDropdown'
import JustifyContent from './JustifyContent'
import Alignments from './Alignments'
import HelperCard from './HelperCard'
import DividerDropdown from './DividerDropdown'
import DropdownSizing from './DropdownSizing'

const DropdownContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Dropdown} parent={UIKits} />
      <Container fluid className="dropdown-page">
        <Row>
          <BasicDropdown />
          <RoundedDropdown/>
          <SplitDropdown/>
          <HeadingDropdown/>
          <DropdownWithInput/>
          <DarkDropdown/>
          <UniqueDropdown/>
          <JustifyContent/>
          <Alignments/>
          <HelperCard/>
          <DividerDropdown/>
          <DropdownSizing/>
        </Row>
      </Container>
    </>
  );
};
export default DropdownContainer;
